import { gql } from '@urql/core';

export const ONFIDO_TOKEN_QUERY = gql`
  query Onfido($input: OnfidoInput!) {
    onfido(input: $input) {
      sdk_token
      workflow_id
    }
  }
`;

export const ONFIDO_HASH_QUERY = gql`
  query onfidoHash {
    onfidoHash {
      hash
    }
  }
`;
